import React, {FC} from 'react';

import {StaticFormItem} from 'components/@common/inputs/static-form-item/static-form-item';
import {CustomSelect} from 'components/form/inputs/custom-select';
import {selectContextRawData} from 'modules/context/context-selector';
import {useAppDispatch, useAppSelector} from 'store/config/hooks';
import {aisSliceActions} from 'store/slices/ais-slice/ais-slice';

import {fetchForecastComments} from '../../api/thunks';
import {FORECAST_COMMENTS_VALUELISTS_URL} from '../../model/constants';
import {selectForecastCommentsFilters} from '../../model/slice';
import styles from './filters.module.less';

export const ForecastCommentsFilters: FC = () => {
    const dispatch = useAppDispatch();
    const {taxCode, status, plannedResponseDate, createdResponseDate} =
        useAppSelector(selectForecastCommentsFilters) ?? {};

    const {organizationId} = useAppSelector(selectContextRawData) ?? {};

    const handleRequestIdChange = (value: string | undefined) => {
        if (value) {
            dispatch(fetchForecastComments({requestId: value}));
        } else {
            dispatch(aisSliceActions.resetForecastComments());
        }
    };

    return (
        <div className={styles.container}>
            <StaticFormItem
                classNames={{wrapperClassName: styles.select}}
                label="Номер запроса"
                customValue={
                    <CustomSelect
                        onChange={handleRequestIdChange}
                        settings={{
                            url: FORECAST_COMMENTS_VALUELISTS_URL,
                            labelPath: 'meaning',
                            valuePath: 'meaning',
                            placeholder: 'Выберите номер запроса',
                            showSearch: true,
                            isClearable: true,
                            fetchTrigger: organizationId,
                            useUndefinedAfterEntriesChanged: true,
                        }}
                        fixedDropdown={false}
                    />
                }
            />
            {status !== undefined && (
                <StaticFormItem
                    classNames={{wrapperClassName: styles.status, valueClassName: styles['text-gray']}}
                    label="Статус"
                    value={status ? 'Завершён' : 'Новый'}
                />
            )}
            {taxCode && (
                <StaticFormItem
                    classNames={{wrapperClassName: styles['form-item'], valueClassName: styles['text-gray']}}
                    label="Налог"
                    value={taxCode}
                />
            )}
            {plannedResponseDate && (
                <StaticFormItem
                    classNames={{wrapperClassName: styles['form-item'], valueClassName: styles['text-gray']}}
                    label="Плановая дата ответа"
                    value={plannedResponseDate}
                />
            )}
            {createdResponseDate && (
                <StaticFormItem
                    classNames={{wrapperClassName: styles['form-item'], valueClassName: styles['text-gray']}}
                    label="Фактическая дата ответа"
                    value={createdResponseDate}
                />
            )}
        </div>
    );
};

ForecastCommentsFilters.displayName = 'ForecastCommentsFilters';
